import React, { useState, useRef } from 'react';
import { Button } from '@pushpay/button';
import Drawer from '@pushpay/drawer';
import { BurgerMenuIcon, CrossIcon, FeedbackIcon, OrgPlaceholderIcon } from '@pushpay/iconography';
import { OrgSwitcherOld } from '@pushpay/shell';
import { clsx } from '@pushpay/styles';
import { useMediaBreakpoint } from '@pushpay/theming';
import { useOnClickOutside } from '@pushpay/utils';
import LinkList from './link-list';
import useStyles from './use-styles';

const Navigation = props => {
  const {
    className,
    classes: classesProp,
    data,
    isSPA,
    mobileButtonLabel,
    'data-pp-at-target': targetId,
    organizations,
    currentOrganization,
    selectOrganizationLabel,
    deprecated,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const wrapper = clsx(className, classes.root);
  const isTabletAndBelow = useMediaBreakpoint('TABLET_AND_BELOW');
  const [isVisibleOnMobile, setIsVisibleOnMobile] = useState(false);
  const buttonRef = useRef(null);
  const navRef = useRef(null);
  useOnClickOutside([buttonRef, navRef], () => {
    setIsVisibleOnMobile(false);
  }, isVisibleOnMobile);
  const navigation = /*#__PURE__*/React.createElement("nav", Object.assign({
    className: wrapper,
    "data-pp-at-target": targetId
  }, rest, {
    ref: navRef
  }), deprecated && !isTabletAndBelow && /*#__PURE__*/React.createElement("header", {
    className: classes.logoWrapper,
    "data-pp-at-target": "nav-org-logo"
  }, data.header.logoUrl ? /*#__PURE__*/React.createElement("img", {
    className: classes.orgLogo,
    src: data.header.logoUrl,
    alt: data.header.displayName,
    "data-pp-at-target": "nav-org-logo-img"
  }) : /*#__PURE__*/React.createElement(OrgPlaceholderIcon, {
    className: classes.orgLogo,
    "data-pp-at-target": "nav-org-logo-placeholder"
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.orgName
  }, data.header.displayName)), deprecated && isTabletAndBelow && organizations && currentOrganization && /*#__PURE__*/React.createElement(OrgSwitcherOld, {
    classes: {
      orgSummary: classes.orgSwitcher
    },
    "data-pp-at-target": `${targetId}-OrgSwitcher`,
    organizations: organizations,
    currentOrganization: currentOrganization,
    isMobile: isTabletAndBelow,
    selectOrganizationLabel: selectOrganizationLabel
  }), /*#__PURE__*/React.createElement(LinkList, {
    isSPA: isSPA,
    items: data.items,
    onSelectItem: () => {
      if (isTabletAndBelow) setIsVisibleOnMobile(false);
    },
    "data-pp-at-target": "nav-link-list",
    nav: navRef
  }), /*#__PURE__*/React.createElement("footer", {
    className: classes.navFooter
  }, /*#__PURE__*/React.createElement("a", {
    className: classes.feedbackLink,
    href: data.footer.url,
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(FeedbackIcon, {
    className: classes.icon,
    "data-pp-at-target": "feedbackIcon"
  }), "Feedback")));

  if (isTabletAndBelow) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.mobileWrapper
    }, /*#__PURE__*/React.createElement(Button, {
      ref: buttonRef,
      "aria-label": mobileButtonLabel,
      title: mobileButtonLabel,
      className: classes.mobileButton,
      type: "button",
      onClick: () => setIsVisibleOnMobile(!isVisibleOnMobile),
      "data-pp-at-target": `${targetId}-mobile-button`
    }, isVisibleOnMobile ? /*#__PURE__*/React.createElement(CrossIcon, {
      "data-pp-at-target": `${targetId}-mobile-close-menuIcon`
    }) : /*#__PURE__*/React.createElement(BurgerMenuIcon, {
      "data-pp-at-target": `${targetId}-mobile-menuIcon`
    })), /*#__PURE__*/React.createElement(Drawer, {
      classes: {
        drawer: classes.drawerPosition,
        mask: classes.drawerPosition
      },
      visible: isVisibleOnMobile,
      placement: "left",
      onClose: () => setIsVisibleOnMobile(false),
      "data-pp-at-target": `${targetId}-mobile-drawer`
    }, navigation));
  }

  return navigation;
};

export default Navigation;